export const SET_TRACKING_URLS = '@@trackingUrls/set';
export const ADD_TRACKING_URL = '@@trackingUrls/add';
export const EDIT_TRACKING_URL = '@@trackingUrls/edit';
export const DELETE_TRACKING_URL = '@@trackingUrls/delete';
